import { createBrowserHistory } from 'history'
import { history } from '../../../../core/backbone'

export default function useHistory() {
  const historyContext = history()

  if (typeof historyContext.handler === 'undefined')
    historyContext.handler = createBrowserHistory()

  return historyContext.handler
}
